/**
 * created by li si yi
 * 内容安全中心
 */
import React, {Component} from 'react';
import {Input, message, Tabs, Pagination, Select, Button, DatePicker, TreeSelect, Icon} from "antd";
import PropTypes from "prop-types";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import BaseComponent from "../../base/BaseComponent";
import BaseTable from "../components/baseTable/BaseTable";
import ReactEcharts from 'echarts-for-react';
import blue from './img/blue.png';
import green from './img/green.png';
import purple from './img/purpleIcon.png';
import yellow from './img/yellow.png';
import red from './img/red.png';
import SensitivityModal from './components/SensitivityModal'
import RecordModal from "./components/RecordModal";
import {uuid,ArrayDuplication} from '../../utils'
import DeptTree from "./components/DeptTree";
import {getColorByState} from "../components/colorByState/colorByState";

const {TabPane} = Tabs;
const {Option} = Select;
const {Search} = Input;
const {RangePicker} = DatePicker;
const {TreeNode} = TreeSelect;
export default class ContentSecurityCenter extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabBarList: [ // 选项卡数据
                {
                    key: '0',
                    name: '发布前检测记录',
                }
            ],
            isShow: true,
            isContentShow: true,
            selectShow: false,
            params: {//分页
                start: 1,
                size: 10,
                deptName: '',
                mediaName: '',
                storyName: '',
                startTime: '',
                endTime: '',
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'serial',
                    key: 'serial',
                    width: 60,
                    ellipsis: true,
                    render: (text, record, index) => {
                        let num = (this.state.params.start - 1) * this.state.params.size + (index + 1);
                        return (
                            <span title={num}>{num}</span>
                        )
                    }
                },
                {
                    title: '稿件名称',
                    dataIndex: 'storyName',
                    key: 'storyName',
                    width: 100,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <span>{record.historyList && record.historyList[0] && record.historyList[0].data && record.historyList[0].data.storyName ? record.historyList[0].data.storyName : record.data && record.data.storyName ? record.data.storyName : ''}</span>
                        )
                    }
                },
                {
                    title: '所属单位',
                    dataIndex: 'deptName',
                    key: 'deptName',
                    width: 100,
                    ellipsis: true,
                    render: (text, record) => {
                        let data = record.historyList && record.historyList[record.historyList.length - 1];
                        return (
                            <span>{data && data.data && data.data.createStorydeptName ? data.data.createStorydeptName : data && data.data && data.data.deptName ? data.data.deptName : ""}</span>
                        )
                    }
                },
                {
                    title: '创建人',
                    dataIndex: 'createUserName',
                    key: 'createUserName',
                    width: 90,
                    ellipsis: true,
                    render: (text, record) => {
                        let data = record.historyList && record.historyList[record.historyList.length - 1];
                        return (
                            <span>{data && data.data && data.data.createStoryUserName ? data.data.createStoryUserName : data && data.data && data.data.createUserName ? data.data.createUserName : ""}</span>
                        )
                    }
                },
                {
                    title: '媒体',
                    dataIndex: 'mediaName',
                    key: 'mediaName',
                    width: 120,
                    ellipsis: true,
                    render: (text, record) => {
                        let data = record.historyList && record.historyList[record.historyList.length - 1];
                        return (
                            <span>{data && data.data && data.data.createStoryMediaName ? data.data.createStoryMediaName : data && data.data && data.data.mediaName ? data.data.mediaName : ""}</span>
                        )
                    }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    width: 150,
                    ellipsis: true,
                    render: (text, record) => {
                        let createTime = record.historyList ? record.historyList[record.historyList.length - 1].createTime : "";
                        return (
                            <div>
                                {createTime ? moment(createTime).format('YYYY-MM-DD HH:mm:ss') : ''}
                            </div>
                        )
                    }
                },
                {
                    title: '最新检测时间',
                    dataIndex: 'updateTime',
                    key: 'updateTime',
                    width: 150,
                    ellipsis: true,
                    render: (text, record) => {
                        let updateTime = record.historyList ? record.historyList[0].updateTime : '';
                        return (
                            <div>
                                {updateTime ? moment(updateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
                            </div>
                        )
                    }
                },
                {
                    title: '检测记录',
                    dataIndex: 'checkCount',
                    key: 'checkCount',
                    width: 100,
                    ellipsis: true,
                    sorter: (a, b) => a.checkCount - b.checkCount,
                    render: (text, record) => {
                        return (
                            <div style={{cursor: 'pointer', color: this.themeBgColor}}
                                 onClick={() => this.recordShow(record)}>{text ? text : "0"}</div>
                        )
                    }
                },
                {
                    title: '发现异常数',
                    dataIndex: 'errorCount',
                    key: 'errorCount',
                    width: 110,
                    ellipsis: true,
                    sorter: (a, b) => a.errorCount - b.errorCount,
                    render: (text, record) => {
                        return (
                            <div
                                style={{cursor: 'pointer', color: this.themeBgColor}}
                                onClick={() => this.recordShow(record)}>{text ? text : "0"}</div>
                        )
                    }
                },
                {
                    title: '未处置异常数',
                    dataIndex: 'noChangeCount',
                    key: 'noChangeCount',
                    width: 120,
                    ellipsis: true,
                    sorter: (a, b) => a.noChangeCount - b.noChangeCount,
                    render: (text, record) => {
                        return (
                            <div
                                style={{cursor: 'pointer', color: this.themeBgColor}}
                                onClick={() => this.recordShow(record)}>{text ? text : "0"}</div>
                        )
                    }
                },
                {
                    title: '稿件状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    width: 130,
                    // ellipsis: true,
                    render: (text, record) => {
                        let name = record.statusName ? record.statusName : "加载中";
                        let color = getColorByState(name);
                        return (
                            <div className={'dotState'}>
                               <div style={{background: color}}></div>
                                <span title={name} style={{
                                    width: 90,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}>{name}</span>
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    width: 90,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <span style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: 'pointer'}} onClick={() => {
                                if (!(record.data && record.data.check_info_url)) {
                                    message.destroy();
                                    message.error('这篇稿件已被删除！');
                                    return
                                }
                                this.getContent(record.data.check_info_url, () => {
                                    if (!this.state.isContentShow) {
                                        message.destroy();
                                        message.error('这篇稿件已被删除！');
                                        return
                                    }
                                }, () => {
                                    window.openPage({
                                        url: "/cm-sites/pms/framereact/index.html#/view/contentSecurityCenter/details",
                                        params: {
                                            checkUrl: record.data,
                                            checkAll: record,
                                        },
                                    })
                                });
                            }}>查看详情</span>
                        )
                    }
                },
            ],
            thisTabKey: '0',// 选项卡当前选中项
            detectionData: [// 检测数据
                {
                    title: '风险总数',
                    itemNum: 0
                },
                {
                    title: '云端检测',
                    itemNum: 0
                },
                {
                    title: '本地检测',
                    itemNum: 0
                },
            ],
            data: [
                {value: 0, name: '敏感词'},
                {value: 0, name: '隐私信息'},
                {value: 0, name: '敏感人物'},
                {value: 0, name: '非法链接'},
                {value: 0, name: '疑似外链'}
            ],
            dataSource: [],
            selectData: [],
            statisticsDataSource: [],//统计展示
            imgData: [// 背景图片
                {
                    url: blue,
                    title: '敏感词',
                    count: 0,
                    cloud: 0,
                    local: 0,
                    percent: 0,
                    type: 'SENSITIVE',
                },
                {
                    url: green,
                    title: '隐私信息',
                    count: 0,
                    cloud: 0,
                    local: 0,
                    percent: 0,
                    type: 'PRIVACY_INFORMATION',
                },
                {
                    url: purple,
                    title: '敏感人物',
                    count: 0,
                    cloud: 0,
                    local: 0,
                    percent: 0,
                    type: 'PERSON_SENSITIVE',
                },
                {
                    url: yellow,
                    title: '非法链接',
                    count: 0,
                    cloud: 0,
                    local: 0,
                    percent: 0,
                    type: 'ILLEGALITY_LINK',
                },
                {
                    url: red,
                    title: '疑似外链',
                    count: 0,
                    cloud: 0,
                    local: 0,
                    percent: 0,
                    type: 'OUTSIDE_CHAIN',
                },
            ],
            deptData: [],//单位数据
            count: 0,
            mediaDataSource: [],//媒体数据
            statusAll: [],
            exportData: [],
            disabled: false,
            key: uuid(),
            thisData: {
                thisType: "",//点击当前的类型
                thisCount: 0,
                thisLocal: 0,
                thisCloud: 0,
            },
        };
    }

    componentDidMount() {
        //列表数据
        this.getDataSource();
        //单位数据
        // this.deptAll();
        //获取媒体数据
        // this.getMediaData();
        //统计展示数据
        this.getItemDataSource();
    }

    componentWillUnmount() {
    }

    // 查询稿件内容是否存在
    getContent = (url, callback, call) => {
        this.request({
            url: url,
            callBack: (res) => {
                if (!res) {
                    this.setState({isContentShow: false}, () => {
                        if (callback) {
                            callback()
                        }
                    });
                } else {
                    if (call) {
                        call()
                    }
                }
            }
        })
    };

    render() {
        return (
            <div className="card-container" style={{marginTop: '15px', marginLeft: '15px'}}>
                {/*选项卡*/}
                {this.renderTabBar()}
                {/*内容*/}
                {this.renderContent()}
                {/*敏感词弹窗*/}
                <SensitivityModal ref={(e) => this.sensitivityModal = e}/>
                {/*安全检测记录弹窗*/}
                <RecordModal key={this.state.key} onCloseCall={() => {
                    this.setState({key: uuid()})
                }} ref={(e) => this.recordModal = e}/>
            </div>
        )
    }

    // 头部搜索
    renderHeader = () => {
        let {mediaDataSource, disabled, params,selectShow} = this.state;
        if (!params.deptName) {
            this.state.disabled = true;
            params.mediaName = "";
        } else {
            this.state.disabled = false;
        }
        return (
            <div className={'securityHeader'}
                 style={{padding: '24px 32px', width: '100%', borderBottom: '1px solid rgba(0,0,0,0.15)'}}>
                    {/* marginRight: 215, */}
                <div style={{ flex: 2, marginRight:24}}>
                    <Button type={"primary"} style={{ textAlign: "left"}} onClick={() => {
                        this.exportRiskRecord()
                    }}>导出检测风险记录</Button>
                </div>
                <div style={{
                    maxWidth: '224px',
                    height: '30px',
                    flex: "1 200px"
                }}>
                    <DeptTree
                        // disabled={disabled}
                        ref={ref => this.DeptTree = ref}
                        deptIdsCall={(deptValue, deptId) => {// value回调
                            this.deptSelect(deptValue, deptId)
                        }}/>
                </div>
                <div style={{flex: "1 200px", maxWidth: "224px", marginRight: 24,}}>
                <Select
                    // disabled={disabled}
                    allowClear={true}
                    placeholder={'请选择媒体名称'}
                    style={{width: "100%"}}
                    onChange={this.mediaHandleChange}
                    value={params.mediaName || []}
                    open={selectShow}
                    onDropdownVisibleChange={open=>{
                                if (disabled) {
                                    message.destroy();
                                    this.setState({selectShow: false})
                                    message.warning("请先选择所属单位!");
                                }else{
                                    this.setState({selectShow: open})
                                }
                    }}
                >
                    {
                        mediaDataSource && mediaDataSource.map((item, index) => {
                            return (
                                <Option value={item.name} key={item.id}>{item.name}</Option>
                            )
                        })
                    }
                </Select>
                </div>
                <Search
                    allowClear={true}
                    placeholder="请输入稿件名称"
                    onSearch={value => {
                        this.state.params.storyName = value;
                        this.state.params.start = 1;
                        this.getDataSource();
                        this.getItemDataSource();
                    }}
                    style={{width: "100%", maxWidth: "224px", height: 30, marginRight: 24, flex: "1 1 200px"}}
                />
                <RangePicker onChange={this.rangePickerOnChange} style={{width: "100%", maxWidth: "245px", flex: "1 1 245px", height: 30}}/>
                <style>
                    {`
                        .securityHeader{
                            display:flex;
                            flex-wrap: nowrap;
                            over-flow:hidden;
                        }
                        .securityHeader .ant-select-selection{
                           background:rgba(0,80,179,0.04);
                           color: rgba(0,0,0,0.45);
                        }
                        .securityHeader .ant-input{
                           background:rgba(0,80,179,0.04);
                           color: rgba(0,0,0,0.45);
                           border-color: rgb(217, 217, 217) !important;
                        }
                        .securityHeader .ant-btn{
                           color:#fff !important;
                        }
                        .securityHeader .ant-input:focus, .ant-input:hover{
                            border-color:${this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")} !important;
                        }
                    `}
                </style>
            </div>
        )
    };
    // 发布前检测记录
    renderContent = () => {
        return (
            <div style={{
                backgroundColor: '#fff',
                borderBottomLeftRadius: '5px',
                borderBottomRightRadius: '5px',
            }}>
                {/*头部内容*/}
                {this.renderHeader()}
                {/*统计*/}
                {this.renderEcharts()}
                {/*表格*/}
                {this.renderTable()}
                {/*分页*/}
                {this.state.dataSource && this.state.dataSource.length > 0 ? this.renderFooter() : ''}
            </div>
        )
    };
    // 已检测风险概览统计
    renderEcharts = () => {
        let {detectionData, imgData, isShow, params} = this.state;
        // let flag = false;
        // if (detectionData[0].itemNum.length > 6) {
        //     flag = true
        // }
        let option = {
            title: {
                show: true,
                text: this.state.detectionData[0].itemNum,
                subtext: '风险',
                textAlign: 'center',
                top: '55',
                left: '70',
                textStyle: {
                    color: '#000',
                    fontSize: 16,
                    fontWeight: 500,
                },
                subtextStyle: {
                    color: 'rgba(0,0,0,.65)',
                    fontSize: 12,
                    fontWeight: 400,
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: "{b}{c}",
                show: true,
                position: function (pos, params, dom, rect, size) {
                    // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
                    var obj = {top: 60};
                    obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
                    return obj;
                },
            },
            color: [
                '#0050B3',
                '#43C89A',
                '#AD7AED',
                '#E6AF55',
                '#F56C6C',
            ],
            series: [
                {
                    name: 'Access From',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center',
                        normal: {
                            show: false,
                            position: 'center',
                            formatter: [
                                '{c}',
                                '{b}'
                            ].join('\n'),
                        },
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '12',
                            color: '#000',
                            fontWeight: 400,
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: this.state.data
                }
            ]
        };
        return (
            <div>
                <div style={{
                    color: '#000',
                    fontWeight: '600',
                    padding: '24px 0 14px 0px',
                    borderBottom: '1px solid #eee',
                    backgroundColor: '#fff',
                    display: 'flex',
                    flexWrap: 'wrap',
                    border: 'none',
                    marginLeft: 32
                }}>
                    <div style={{width: 4, height: 12, background: '#0050B3', marginTop: 5, marginRight: 5}}/>
                    已检测风险概览
                </div>
                <div style={{
                    display: 'flex',
                    margin: '0 32px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div>
                        <ReactEcharts
                            onEvents={this.onEvents}
                            onChartReady={(ref) => {
                                this.reactEcharts = ref;
                                this.reactEcharts.on('mouseover', {seriesName: 'Access From'}, params => {
                                    this.reactEcharts.setOption({
                                        title: {
                                            show: false
                                        }
                                    })
                                });

                                this.reactEcharts.on('mouseout', {seriesName: 'Access From'}, params => {
                                    this.reactEcharts.setOption({
                                        title: {
                                            show: true
                                        }
                                    })
                                });
                            }}
                            option={option}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: 150, height: 150}}
                        />
                    </div>
                    <div style={{position: 'absolute', top: 135, left: 40}}>发现异常数</div>
                    {/*<div style={{*/}
                    {/*    width: 140,*/}
                    {/*    height: 120,*/}
                    {/*    background: 'rgba(0,80,179,0.04)',*/}
                    {/*    display: 'flex',*/}
                    {/*    flexDirection: 'column',*/}
                    {/*    justifyContent: 'space-around',*/}
                    {/*    border: '1px solid rgba(0,80,179,0.08)',*/}
                    {/*    alignSelf: 'center',*/}
                    {/*    padding: '5px 8px',*/}
                    {/*    marginRight: 8*/}
                    {/*}}>*/}
                    {/*    {*/}
                    {/*        detectionData && detectionData.map((item, index) => {*/}
                    {/*            return (*/}
                    {/*                <div*/}
                    {/*                    style={{*/}
                    {/*                        display: 'flex',*/}
                    {/*                        justifyContent: 'space-between',*/}
                    {/*                    }}*/}
                    {/*                    key={index}>*/}
                    {/*                    <span style={{*/}
                    {/*                        overflow: 'hidden',*/}
                    {/*                        whiteSpace: 'nowrap',*/}
                    {/*                        textOverflow: 'ellipsis'*/}
                    {/*                    }}>{item.title}</span>*/}
                    {/*                    <div title={item.itemNum} style={{*/}
                    {/*                        color: 'rgba(0,0,0,0.85)',*/}
                    {/*                        fontWeight: 600,*/}
                    {/*                        fontSize: '15px',*/}
                    {/*                        display: 'flex'*/}
                    {/*                    }}>*/}
                    {/*                        <div style={{*/}
                    {/*                            width: 65,*/}
                    {/*                            textAlign: 'end',*/}
                    {/*                        }}>{item.itemNum}</div>*/}
                    {/*                        /!*<span>个</span>*!/*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*            )*/}
                    {/*        })*/}
                    {/*    }*/}
                    {/*</div>*/}
                    {
                        imgData && imgData.map((item, index) => {
                            return (
                                <div key={index} style={{
                                    width: 187,
                                    height: 120,
                                    lineHeight: '25px',
                                    backgroundImage: `url(${item.url})`,
                                    padding: '34px 0 34px 40px',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    marginRight: 8
                                }}
                                     onClick={(e) => {
                                         this.state.thisData.thisType = item.type;
                                         this.getClickDataSource(() => {
                                             let thisData = this.state.thisData;
                                             this.sensitivityShow(thisData, item, params);
                                         });
                                     }}
                                >
                                    <span style={{fontSize: '30px'}}>{item.percent}</span>%
                                    <div>{item.title} （{item.count}个）</div>
                                </div>
                            )
                        })
                    }
                </div>

            </div>
        )
    };
    // 选项卡
    renderTabBar = () => {
        return (
            <Tabs type="card" onChange={this.changeTabBar}>
                {
                    this.state.tabBarList.map((item) => {
                        return (
                            <TabPane tab={item.name} key={item.key} style={{backgroundColor: '#fff'}}/>
                        )
                    })
                }
            </Tabs>
        )
    };
    // 表格数据
    renderTable = () => {
        let {dataSource, columns} = this.state;
        return (
            <div style={{padding: '0px 32px'}}>
                <div style={{
                    color: '#000',
                    fontWeight: '600',
                    padding: '24px 0 14px 0px',
                    borderBottom: '1px solid #eee',
                    backgroundColor: '#fff',
                    display: 'flex'
                }}>
                    <div style={{width: 4, height: 12, background: '#0050B3', marginTop: 5, marginRight: 5}}/>
                    检测风险记录
                </div>
                <Scrollbars autoHeight autoHeightMax={"calc(100vh - 475px - 67px - 15px )"} autoHide>
                    <BaseTable dataSource={dataSource} columns={columns}
                               pagination={false}/>
                </Scrollbars>
            </div>
        )
    };
    // 分页
    renderFooter = () => {
        let {params, count} = this.state;
        // 获取当前tab参数
        let {start, size} = params;
        let windowHeight = window.innerHeight;
        return (
            // style={{marginTop: windowHeight > 937 ? '28px' : '15px'}}
            <div className={'pagination'} style={{ paddingBottom: "17px", paddingTop: "17px"}}>
                <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={count}
                    showQuickJumper={true}
                    onChange={this.handlePageChange}
                    onShowSizeChange={this.handlePageSizeChange}
                />
            </div>
        )
    };
    getStatus = (item, callback) => {
        this.request({
            url: item.data.check_info_url,
            callBack: (res) => {
                if (res) {
                    callback(res.statusName);
                }else{
                    callback(false)
                }
            }
        });
    };

    // 获取列表数据
    getDataSource = (callback) => {
        let params = this.state.params;
        this.request({
            url: "/cm-sites-sys/contentCheck/getAllCheckLogGroupByKey",
            method: 'get',
            body: params,
            callBack: (res) => {
                let dataSource = [];
                let count = 0;
                if (res) {
                    dataSource = res.data;
                    if (callback) {
                        callback(dataSource)
                    }
                    if (!callback) {
                        count = res.count;
                        let itemsToFetchStatusFor = [];
                        dataSource.forEach((item, index) => {
                            if (item.data && item.data.check_info_url) {
                                itemsToFetchStatusFor.push({item, index});
                            }
                        });

                        itemsToFetchStatusFor.forEach(({item, index}) => {
                            this.getStatus(item, (statusName) => {
                                if (statusName) {
                                    dataSource[index].statusName = statusName;
                                } else {
                                    dataSource[index].statusName = "已删除";
                                }
                                this.setState({dataSource, count})
                            });
                        });
                    }
                }
                if (!callback) {
                    this.setState({dataSource, count});
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 获取媒体名称
    getMediaData = (deptId) => {
        if (!deptId) {
            return false
        }
        this.request({
            url: "/cm-sites-pms/media/getMediaByDept",
            body: {deptId: deptId},
            callBack: (res) => {
                let mediaDataSource = [];
                if (res) {
                    res && res.map((item, index) => {
                        if (item.mediaTypeCode == 'website' || item.mediaTypeCode == 'material' || item.mediaTypeCode == 'webNews') {
                            mediaDataSource.push(item)
                        }
                    });
                    // // 去重
                    // mediaDataSource.forEach(item => {
                    //     if (!newMediaDataSource.some(e => e.id === item.id)) {
                    //         newMediaDataSource.push(item)
                    //     }
                    // });
                    // console.log("========",newMediaDataSource)
                }
                let newMediaDataSource = ArrayDuplication(mediaDataSource, "id");
                this.setState({mediaDataSource: newMediaDataSource});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 获取首页统计数据
    getItemDataSource = () => {
        let {imgData, detectionData, option} = this.state;
        let params = {};
        let bodyVal = [
            {
                "queryTypeEnum": "IS",
                "fieldName": 'data.createStorydeptName',
                "queryRelationTypeEnum": "AND",
                "valueTypeEnum": "STRING",
                "value": this.state.params.deptName,
                "queryList": null
            },
            {
                "queryTypeEnum": "IS",
                "fieldName": "data.createStoryMediaName",
                "queryRelationTypeEnum": "AND",
                "value": this.state.params.mediaName,
                "valueTypeEnum": "STRING",
                "queryList": null
            },
            {
                "queryTypeEnum": "LIKE",
                "fieldName": "data.storyName",
                "queryRelationTypeEnum": "AND",
                "value": this.state.params.storyName,
                "valueTypeEnum": "BOOLEAN",
                "queryList": null
            },
            {
                "value": this.state.params.startTime && this.state.params.endTime ? true : false,
                "fieldName": 'time',
                "oneSearch": {
                    "queryRelationTypeEnum": "AND",
                    queryList: [
                        {
                            "queryTypeEnum": "GTE",
                            "fieldName": "createTime",
                            "queryRelationTypeEnum": "AND",
                            "value": this.state.params.startTime,
                            "valueTypeEnum": "LONG",
                            "queryList": null
                        },
                        {
                            "queryTypeEnum": "LTE",
                            "fieldName": "createTime",
                            "queryRelationTypeEnum": "AND",
                            "value": this.state.params.endTime,
                            "valueTypeEnum": "LONG",
                            "queryList": null
                        }
                    ]
                },
                'moreSearch': [
                    {
                        "queryTypeEnum": "GTE",
                        "fieldName": "createTime",
                        "queryRelationTypeEnum": "AND",
                        "value": this.state.params.startTime,
                        "valueTypeEnum": "LONG",
                        "queryList": null
                    },
                    {
                        "queryTypeEnum": "LTE",
                        "fieldName": "createTime",
                        "queryRelationTypeEnum": "AND",
                        "value": this.state.params.endTime,
                        "valueTypeEnum": "LONG",
                        "queryList": null
                    }
                ]
            }
        ];
        let flag = 0;
        bodyVal.forEach(item => {
            if (item.value) {
                flag = flag + 1;
            }
        });
        if (flag == 1) {
            bodyVal.forEach(item => {
                if (item.value && item.fieldName == 'time') {
                    params = item.oneSearch;
                } else if (item.value) {
                    params = item;
                }
            });
        } else if (flag > 1) {
            params = {
                "queryRelationTypeEnum": "AND",
                "queryList": [],
            };
            bodyVal.forEach(item => {
                if (item.value && item.fieldName == 'time') {
                    item.moreSearch.forEach(itemTime => {
                        params.queryList.push(itemTime);
                    })
                } else if (item.value) {
                    params.queryList.push(item);
                }
            });
        } else {
            params = {};
        }
        this.request({
            url: "/cm-sites-sys/contentCheck/getCheckResultObjectByTypt",
            body: {queryStr: params, "ifNeedWordsDate": true},
            contentType: 'json',
            method: 'post',
            callBack: (res) => {
                if (res && res.data) {
                    // 再次调用时清零
                    imgData.map(item => {
                        item.count = 0;
                    });
                    detectionData.map(item => {
                        item.itemNum = 0
                    });
                    //计算每一项个数
                    for (let key in res.data[0]) {
                        switch (key) {
                            case 'count':
                                calc(res.data[0][key], (num1) => {
                                    this.state.detectionData[0].itemNum = num1;
                                });
                                break;
                            case 'CLOUD_CHECK':
                                calc(res.data[0][key], (num1) => {
                                    this.state.detectionData[1].itemNum = num1;
                                });
                                break;
                            case 'LOCAL_CHECK':
                                calc(res.data[0][key], (num1) => {
                                    this.state.detectionData[2].itemNum = num1;
                                });
                                break;
                            case 'SENSITIVE':
                                imgData[0].count = res.data[0][key];
                                break;
                            case 'PRIVACY_INFORMATION':
                                imgData[1].count = res.data[0][key];
                                break;
                            case 'PERSON_SENSITIVE':
                                imgData[2].count = res.data[0][key];
                                break;
                            case 'OUTSIDE_CHAIN':
                                imgData[4].count = res.data[0][key];
                                break;
                        }
                    }

                    // 计算超出显示万和亿 保留一位小数
                    function calc(num, call) {
                        let num1 = num;
                        if (num1 >= 100000 && num1 < 100000000) {
                            num1 = (num1 / 10000).toFixed(1) + "万"
                        }
                        if (num1 >= 100000000) {
                            num1 = (num1 / 100000000).toFixed(1) + "亿"
                        }
                        if (call) {
                            call(num1)
                        }
                    }

                    // 计算每一项百分比
                    imgData.map(item => {
                        if (item.count) {
                            item.percent = ((item.count / res.data[0].count) * 100).toFixed(1);
                        } else {
                            item.percent = 0;
                        }
                    });
                    // echarts数据
                    this.state.data.map((item, index) => {
                        imgData.map((Item, Index) => {
                            if (index == Index) {
                                item.value = Item.count;
                            }
                        });
                    });
                    this.setState({option});
                }
                this.setState({});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 点击当前的传参计算数据
    getClickDataSource = (callback) => {
        let params = {};
        let bodyVal = [
            {
                "queryTypeEnum": "IS",
                "fieldName": 'data.createStorydeptName',
                "queryRelationTypeEnum": "AND",
                "valueTypeEnum": "STRING",
                "value": this.state.params.deptName,
                "queryList": null
            },
            {
                "queryTypeEnum": "IS",
                "fieldName": "data.createStoryMediaName",
                "queryRelationTypeEnum": "AND",
                "value": this.state.params.mediaName,
                "valueTypeEnum": "STRING",
                "queryList": null
            },
            {
                "queryTypeEnum": "LIKE",
                "fieldName": "data.storyName",
                "queryRelationTypeEnum": "AND",
                "value": this.state.params.storyName,
                "valueTypeEnum": "BOOLEAN",
                "queryList": null
            },
            {
                "value": this.state.params.startTime && this.state.params.endTime ? true : false,
                "fieldName": 'time',
                "oneSearch": {
                    "queryRelationTypeEnum": "AND",
                    queryList: [
                        {
                            "queryTypeEnum": "GTE",
                            "fieldName": "createTime",
                            "queryRelationTypeEnum": "AND",
                            "value": this.state.params.startTime,
                            "valueTypeEnum": "LONG",
                            "queryList": null
                        },
                        {
                            "queryTypeEnum": "LTE",
                            "fieldName": "createTime",
                            "queryRelationTypeEnum": "AND",
                            "value": this.state.params.endTime,
                            "valueTypeEnum": "LONG",
                            "queryList": null
                        }
                    ]
                },
                'moreSearch': [
                    {
                        "queryTypeEnum": "GTE",
                        "fieldName": "createTime",
                        "queryRelationTypeEnum": "AND",
                        "value": this.state.params.startTime,
                        "valueTypeEnum": "LONG",
                        "queryList": null
                    },
                    {
                        "queryTypeEnum": "LTE",
                        "fieldName": "createTime",
                        "queryRelationTypeEnum": "AND",
                        "value": this.state.params.endTime,
                        "valueTypeEnum": "LONG",
                        "queryList": null
                    }
                ]
            }
        ];
        let flag = 0;
        bodyVal.forEach(item => {
            if (item.value) {
                flag = flag + 1;
            }
        });
        if (flag == 1) {
            bodyVal.forEach(item => {
                if (item.value && item.fieldName == 'time') {
                    params = item.oneSearch;
                } else if (item.value) {
                    params = item;
                }
            });
        } else if (flag > 1) {
            params = {
                "queryRelationTypeEnum": "AND",
                "queryList": [],
            };
            bodyVal.forEach(item => {
                if (item.value && item.fieldName == 'time') {
                    item.moreSearch.forEach(itemTime => {
                        params.queryList.push(itemTime);
                    })
                } else if (item.value) {
                    params.queryList.push(item);
                }
            });
        } else {
            params = {};
        }
        this.request({
            url: "/cm-sites-sys/contentCheck/getCheckResultObjectByTypt",
            body: {queryStr: params, "ifNeedWordsDate": true, "type": this.state.thisData.thisType},
            contentType: 'json',
            method: 'post',
            callBack: (res) => {
                let thisCloud = 0;
                let thisLocal = 0;
                let thisCount = 0;
                if (res && res.data) {
                    // 当前点击类型计算数据
                    res.data.map(Item => {
                        thisCloud = Item.CLOUD_CHECK;
                        thisLocal = Item.LOCAL_CHECK;
                        thisCount = Item.count;
                    });
                }
                this.state.thisData.thisCloud = thisCloud;
                this.state.thisData.thisLocal = thisLocal;
                this.state.thisData.thisCount = thisCount;
                callback();
                this.setState({});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 获取所有部门
    // deptAll = () => {
    //     let params = {
    //         id: '0'
    //     };
    //     this.request({
    //         url: '/cm-sites-sys/dept/getAllChildDeptList',
    //         method: 'post',
    //         body: params,
    //         callBack: (res) => {
    //             let deptData = [];
    //             if (res) {
    //                 deptData = res;
    //             }
    //             this.setState({treeData: deptData})
    //         }
    //     })
    // };
    // 安全记录
    recordShow = (record) => {
        if (!(record.data)) {
            message.destroy();
            message.error('这篇稿件异常！');
            return
        }
        this.recordModal.showModal(record);
    };
    // 敏感词等弹窗
    sensitivityShow = (thisData, item, params) => {
        this.sensitivityModal.showModal(thisData, item, params);
    };
    // 分页改变
    handlePageChange = (page, size) => {
        this.updateDataSource(page, size);
    };

    handlePageSizeChange = (page, size) => {
        this.updateDataSource(1, size);
    };

    updateDataSource = (start, size) => {
        let updatedParams = {
            ...this.state.params,
            start: start,
            size: size
        };

        this.setState({ params: updatedParams }, () => {
            this.getItemDataSource();
            this.getDataSource();
        });
    };
    // 日期改变
    rangePickerOnChange = (date, dateString) => {
        // console.log(date, dateString);
        let {params} = this.state;
        // new Date(new Date().toLocaleDateString()).getTime();
        params.startTime = date[0] ? new Date(new Date(date[0]).toLocaleDateString()).getTime() : "";
        params.endTime = date[1] ? new Date(new Date(date[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1 : "";
        this.getItemDataSource();
        this.getDataSource();
    };
    // 选项卡改变
    changeTabBar = (key) => {
        this.state.thisTabKey = key;
        this.getDataSource();
    };

    // 部门名称改变
    deptSelect = (value, deptId) => {
        let {params} = this.state;
        params.deptName = value ? value : "";//option.key
        params.mediaName = "";
        this.state.params.start = 1;
        this.setState({},()=>{
            this.getMediaData(deptId);
            this.getItemDataSource();
            this.getDataSource();
        });
    };
    // 媒体名称改变
    mediaHandleChange = (value) => {
        let {params} = this.state;
        params.mediaName = value ? value : "";
        // if (params.mediaName) {
        //     this.state.disabled = true;
        //     params.deptName = "";
        //     this.DeptTree.refresh();
        // } else {
            this.state.disabled = false;
        // }
        this.state.params.start = 1;
        this.getItemDataSource();
        this.getDataSource();
    };

    // 导出记录
    exportRiskRecord() {
        this.request({
            url: '/cm-sites-dispatch-product/contentCheck/getAllCheckLogGroupByKey',
            method: 'get',
            body: this.state.params,
            callBack: () => {
                message.destroy();
                message.success("操作成功，后台正在生成文件，完成后会自动下载。");
            }
        })
    }
};

ContentSecurityCenter.defaultProps = {};
ContentSecurityCenter.propTypes = {};